import { gql } from '~src/generated/portal/gql';

export const testScriptStatus = gql(`
  subscription TestScriptStatus($projectId: String!, $deviceId: String!, $testId: String!) {
    testScriptStatusUpdated {
      id
      adkTestScriptStatus(projectId: $projectId, deviceId: $deviceId, testId: $testId) {
        id
        timeStamp
        testIndex
        actionIndex
        testExecutionId
        description
        tests {
          initialPageStatus {
            initialPage
            status
            error
          }
          description
          actions {
            description
            preCommands
            expectations
            postCommands
            status
            error 
            preScreenshots {
              name
              status
              images {
                src
                width
                height
                format
                isOriginal
              }
              takenAt
            } 
            postScreenshots {
              name
              status
              images {
                src
                width
                height
                format
                isOriginal
              }
              takenAt
            }
            totalScreenshots 
            allScreenshots {
              name
              status
              images {
                src
                width
                height
                format
                isOriginal
              }
              takenAt
            }
          }
          error
        }
        error
      }
    }
  }
`);
